<template>
  <v-container
    fluid
    style="height: 100%; margin:0px; padding:0px; min-height: inherit"
    class="d-flex flex-row"
  >
    <volunteer-profile-left-section class="hidden-sm-and-down" />
    <volunteer-profile-needs-section />
  </v-container>
</template>
<script>
import VolunteerProfileLeftSection from "./VolunteerProfileLeftSection.vue";
import VolunteerProfileNeedsSection from "./VolunteerProfileNeedsSection.vue";
export default {
  components: { VolunteerProfileNeedsSection, VolunteerProfileLeftSection }
};
</script>
